
import { defineComponent, ref } from "vue";
import { getAllContainer } from "@/service/container.service";
import csv from "csvtojson";
import { Parameter } from "@/types/parameter.type";
import { Container } from "@/types/container.type";
import { getParameter } from "@/service/parameter.service";
import { FormInstance, ElForm, UploadFile } from "element-plus";
import { UploaderDataFilter, TrainingData } from "@/types/trainingData.type";
import { dateFormatFile } from "@/utils/date.utils";
import { convertJSONStringToArrayString } from "@/utils/convertType.util";
import ElMessage from "element-plus/lib/components/message";
import DataUploadInfoDialogComponent from "@/components/information/DataUploadInfoDialog.component.vue";
import UploadHeaderComponent from "@/components/uploader/UploadHeader.component.vue";
import { addSamplingPointType } from "@/service/samplingpoint.service";

export default defineComponent({
  components: {
    DataUploadInfoDialogComponent,
    UploadHeaderComponent,
  },
  props: {
    checked: { type: Boolean },
  },
  setup() {
    const ruleFormRef = ref<FormInstance>();
    const originList = [
      {
        value: "CONTROL_ALGAS",
        label: "CONTROL DE ALGAS (SUPERFICIE)",
      },
      {
        value: "SCADA",
        label: "SCADA",
      },
      {
        value: "LABORATORIO",
        label: "LABORATORIO",
      },
      {
        value: "AQUACORP",
        label: "AQUACORP",
      },
      {
        value: "MULTIPARAMETRICA",
        label: "MULTIPARAMÉTRICA",
      },
      {
        value: "DUERO",
        label: "DUERO",
      },
      {
        value: "SONDA_DQO",
        label: "SONDA DQO",
      },
      {
        value: "SINTETICO",
        label: "SINTÉTICO",
      },
      {
        value: "OTRO",
        label: "OTRO",
      },
    ];

    originList.sort((a, b) => a.label.localeCompare(b.label));
    return { originList, ruleFormRef };
  },
  data() {
    return {
      uploaderDataFilter: {} as UploaderDataFilter, //- Obj. del formulario
      file: [] as Array<{ name: string; url: string | ArrayBuffer | null | undefined }>,
      containers: [] as Container[], //- Lista de contenedores del sistema
      parameters: [] as Parameter[], // - Lista de parámetros del sistema
      headerCodeParameter: [] as string[],
      headerP: [] as Parameter[],
      paramsNotFound: [] as string[], //- Parámetros del fichero que no se encuentran en la plataforma
      parametersWithoutRange: [] as string[],
      headerPCopy: [] as Parameter[],
      visibleCheck: false,
      infoVisible: false, // Control para abrir y cerrar la venta informativa
      created: false,
      rules: {
        samplingPoint: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
        origin: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
        dataFile: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
      },

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      jsonObj: "" as any | undefined,

      isNewSamplingPointType: false,
      selectedContainerTypeId: undefined as number | undefined,
    };
  },
  async mounted() {
    this.containers = await getAllContainer();
    this.containers.sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));
    this.parameters = (await getParameter(undefined, undefined)).data;
  },
  methods: {
    async handleSamplingPointTypeChange(value: string) {
      const existing = this.uploaderDataFilter.container?.containerType?.samplingPointType?.some(
        (opt) => opt.name?.toLowerCase() === value.toLowerCase()
      );

      if (!existing) {
        this.isNewSamplingPointType = true;
      } else {
        this.uploaderDataFilter.samplingPointType = value;
        this.isNewSamplingPointType = false;
      }
    },
    async checkNewSPType() {
      const samplingPointName = this.uploaderDataFilter.samplingPointType;

      if (this.isNewSamplingPointType && samplingPointName && this.uploaderDataFilter.container) {
        const existing = this.uploaderDataFilter.container.containerType?.samplingPointType?.some(
          (opt) => opt.name?.toLowerCase() === samplingPointName.toLowerCase()
        );
        this.selectedContainerTypeId = this.uploaderDataFilter.container.containerType?.id;
        if (!existing) {
          await addSamplingPointType(samplingPointName, this.selectedContainerTypeId);
        }

        this.isNewSamplingPointType = false;
      }
    },
    /**
     * INTERPRETAR EL FICHERO CARGADO
     */
    recognizeParameters(headerFile: string[]) {
      for (let index of headerFile) {
        let paramHeader: Parameter | undefined;
        for (let parameter of this.parameters) {
          if (parameter.code && index.includes(parameter.code)) {
            paramHeader = parameter;
          }
        }
        if (paramHeader && paramHeader.code) {
          this.headerP.push(paramHeader);
          this.headerPCopy.push(paramHeader);
          this.headerCodeParameter.push(paramHeader.code);
          if (!paramHeader.physicalRange) {
            this.parametersWithoutRange.push(paramHeader.code);
          }
        } else {
          if (!index.toLowerCase().includes("fecha")) {
            this.paramsNotFound.push(index);
          } else {
            this.headerCodeParameter.push(index);
          }
        }
      }

      this.visibleCheck = true;
    },
    /**
     * Leer el archivo
     * @param file
     */
    async handleChange(file: UploadFile) {
      const textFile = await file.raw?.text();
      if (textFile) {
        this.uploaderDataFilter.dataFile = textFile;
        this.jsonObj = await csv({
          delimiter: "auto",
          trim: true,
          ignoreEmpty: false,
          nullObject: true,
        }).fromString(this.uploaderDataFilter.dataFile);

        //- Reconocemos la cabecera
        const headerFile = convertJSONStringToArrayString(this.jsonObj[0]);
        this.recognizeParameters(headerFile);
      }
    },

    handleRemove() {
      this.paramsNotFound = [];
      this.headerP = [] as Parameter[];
      this.$emit("remove");
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    generateData(data: any[]) {
      let trainingData: TrainingData[] = [];
      if (this.parametersWithoutRange.length == 0) {
        for (let line of data) {
          if (line.length !== 0) {
            const arrayLine = Object.entries(line);
            for (let i = 1; i < arrayLine.length; i++) {
              if (arrayLine !== undefined) {
                const { date, value } = this.generateUpload(i, arrayLine);

                // Comprobar que los campos no esten vacíos

                const samplingPointType = this.uploaderDataFilter?.samplingPointType;
                if (date !== "Invalid date" && date && this.uploaderDataFilter.origin) {
                  const item = {
                    dateTime: date,
                    raw: value,
                    clean: undefined,
                    value: undefined,
                    magnitude: this.headerPCopy[i - 1].name,
                    codeParameter: this.headerPCopy[i - 1],
                    origin: this.uploaderDataFilter.origin,
                    status: this.created ? "CREATED_RAW" : "ORIGINAL",
                    samplingPointType: samplingPointType ? samplingPointType : null,
                    container: this.uploaderDataFilter.container,
                    event: this.uploaderDataFilter.event || undefined,
                  } as TrainingData;

                  trainingData.push(item);
                }
              }
            }
          }
        }
      }

      return trainingData;
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    generateUpload(i: number, arrayLine: any) {
      let date = arrayLine[0][1]
        ? dateFormatFile(arrayLine[0][1] as string, "Europe/Madrid")
        : undefined;

      let value = arrayLine[i][1] ? this.parseNumber(arrayLine[i][1]) : undefined;

      return { date, value };
    },
    parseNumber(valueString: string) {
      let value = Number(valueString.replace(/,/g, "."));
      if (value === undefined) {
        value = 0;
      }

      return value;
    },

    async handleSubmit() {
      if (this.uploaderDataFilter.dataFile) {
        const csvObj_2 = await csv({
          delimiter: "auto",
          headers: this.headerCodeParameter,
          trim: true,
          ignoreEmpty: false,
          nullObject: true,
        }).fromString(this.uploaderDataFilter.dataFile);

        return this.generateData(csvObj_2);
      } else {
        // Selecciona una imagen
        ElMessage.error(this.$t("error.notFile"));
      }
    },
    async createForm() {
      this.visibleCheck = false;
    },

    closeFormDialog() {
      this.visibleCheck = false;
      this.headerP = [] as Parameter[];
    },

    /**
     * MANUAL
     */
    async handleSubmitManual() {
      return this.jsonObj;
    },

    async valdidate() {
      let valid;
      valid = await (this.$refs["ruleFormRef"] as InstanceType<typeof ElForm>).validate();
      if (!valid) {
        throw new Error("validation");
      }

      return true;
    },
  },
  watch: {
    "uploaderDataFilter.container": {
      handler(newVal) {
        if (newVal?.containerType?.samplingPointType) {
          newVal.containerType.samplingPointType.sort((a: { name: any }, b: { name: any }) =>
            (a.name ?? "").localeCompare(b.name ?? "")
          );
        }
      },
      immediate: true,
      deep: true,
    },
  },
});
